import { Fragment, useMemo } from "react";

import CardTag from "./CardTag";

export default function Card({
  isAdmin,
  title,
  subtitle,
  onClick,
  actions,
  tags,
  isProjectAccessible = true,
  ...otherProps
}) {
  const handleCardClick = (e) => {
    if (!isProjectAccessible && !isAdmin) {
      return;
    }
    onClick(e);
  };

  const truncatedSubtitle = useMemo(() => {
    const [projectType, dateCreated] = subtitle.split(" • ");

    if (projectType.length > 10 && dateCreated) {
      // selects the the substring from the 7 char onwards and replaces it with "..."
      const trunacetedProjectType = projectType.replace(
        /(?<=\b\w{7})\w+/gi,
        "...",
      );

      return `${trunacetedProjectType} • ${dateCreated}`;
    }

    return subtitle;
  }, [subtitle]);

  return (
    <div
      className={`rounded-lg bg-white w-[267px] h-[174px] px-[22px] pt-[11px] pb-[10px] flex flex-col justify-between shadow-lg hover:shadow-xl transition-shadow duration-300 ${
        !isProjectAccessible && !isAdmin
          ? "cursor-not-allowed"
          : "cursor-pointer"
      }`}
      onClick={handleCardClick}
      {...otherProps}
    >
      <div className="flex flex-row-reverse mb-[7px] justify-between">
        {tags?.map((tag, i) => (
          <CardTag
            key={i}
            tag={tag}
            isProjectAccessible={isProjectAccessible}
          />
        ))}
      </div>
      <h2 className="text-xxl font-bold text-right h-[53px] text-ellipsis">
        {title}
      </h2>
      <span className="text-gray-400 font-normal text-[11px] mt-[3px] mb-[7px] h-[15px] text-right">
        {truncatedSubtitle}
      </span>
      <div className="h-[2px] w-full bg-[#EEF0F2]" />

      <div className="flex items-center justify-end pt-[5px] gap-[12px]">
        {actions.map((action, idx) => (
          <Fragment key={idx}>{action}</Fragment>
        ))}
      </div>
    </div>
  );
}
